import React from "react";
import { Box, TextField, Typography } from "@mui/material";

function DailySettings({ day, dayIndex, versusSettings, setVersusSettings }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 2,
        gap: 2,
      }}
    >
      <Typography sx={{ width: 100 }}>Day {day.step}:</Typography>
      <TextField
        label="Above FPTS"
        type="number"
        value={day.above}
        onChange={(e) => {
          const modeIndex = versusSettings.gameModes.findIndex(
            (m) => m.gameMode === 5
          );
          const newSettings = { ...versusSettings };
          newSettings.gameModes[modeIndex].daily[dayIndex].above = Number(
            e.target.value
          );
          setVersusSettings(newSettings);
        }}
        sx={{ width: 120 }}
        size="small"
      />
      <TextField
        label="Below FPTS"
        type="number"
        value={day.below}
        onChange={(e) => {
          const modeIndex = versusSettings.gameModes.findIndex(
            (m) => m.gameMode === 5
          );
          const newSettings = { ...versusSettings };
          newSettings.gameModes[modeIndex].daily[dayIndex].below = Number(
            e.target.value
          );
          setVersusSettings(newSettings);
        }}
        sx={{ width: 120 }}
        size="small"
      />
      <TextField
        label="Winnings"
        type="number"
        value={day.winnings || 0}
        onChange={(e) => {
          const modeIndex = versusSettings.gameModes.findIndex(
            (m) => m.gameMode === 5
          );
          const newSettings = { ...versusSettings };
          newSettings.gameModes[modeIndex].daily[dayIndex].winnings = Number(
            e.target.value
          );
          setVersusSettings(newSettings);
        }}
        sx={{ width: 120 }}
        size="small"
      />
    </Box>
  );
}

export default DailySettings;
